<template>
  <div class="originality-story">
    <div class="originality-banner">
      <img src="~@/assets/icon/home/feedback_banner.jpg" alt="">
    </div>
    <div class="originality-bg">
      <second-title 
      letter="A"
      enTitle="fter-sales service"
      current_add="摩旅服务"
      add_one="首页"
      add_tow="无极服务"
      add_three="摩旅服务"
      >
      </second-title>
      <div style="padding:15px">
        <p style="font-size:16px;margin-top:10px;color:#8B8B8B">建设中,敬请期待......</p>
      </div>
    </div>
    <base-footers></base-footers>
  </div>
</template>
<script>
import SecondTitle from "@/components/SecondTitle.vue";
import Footers from "@/components/Footers.vue";
export default {
  name:'originalityStory',
  components:{
    SecondTitle,
    BaseFooters:Footers,
  }
}
</script>
<style lang="scss">
@import './travelService.scss'
</style>